<template>
    <div class="toll-calculation">
        <div class="toll-container">
            <select
                name="start_id"
                id="start_id"
                class="select2"
                :data-placeholder="trans.get('map.choose_start_point')"
                ref="start_id"
            ></select>
        </div>
        <div class="toll-container">
            <select
                name="exit_id"
                id="exit_id"
                class="select2"
                :data-placeholder="trans.get('map.choose_end_point')"
                ref="exit_id"
            ></select>
        </div>
        <div class="toll-container">
            <select
                name="vehicle_category"
                id="vehicle_category"
                class="select2"
                :data-placeholder="trans.get('map.vehicle_category')"
                ref="vehicle_category"
            ></select>
        </div>
        <div class="toll-response-data" v-if="price && tollInfo">
            <div class="response-row">
                <inline-svg
                    name="map/pin"
                    width="16"
                    height="16"
                    classes="toll-icon"
                />
                <input
                    type="text"
                    v-model="distance"
                    class="toll-input"
                    readonly
                />
                <span>km</span>
            </div>
            <div class="response-row">
                <inline-svg
                    name="map/clock"
                    width="16"
                    height="16"
                    classes="toll-icon"
                />
                <input type="text" v-model="time" class="toll-input" readonly />
                <span>h</span>
            </div>
            <div class="response-row">
                <inline-svg
                    name="map/money"
                    width="16"
                    height="16"
                    classes="toll-icon"
                />
                <input
                    type="text"
                    v-model="price"
                    class="toll-input"
                    readonly
                />
                <span>€</span>
            </div>
        </div>
    </div>
</template>

<script>
import inlineSvg from "./inlineSvg.js";
import { mapGetters } from "vuex";
import axios from "./axios.js";
import Vue from "vue";

export default {
    name: "TollCalculation",
    components: {
        inlineSvg,
    },
    props: {
        urlKey: {
            type: String,
        },
    },

    data() {
        return {
            distance: null,
            time: null,
            start_id: null,
            exit_id: null,
            vehicle_category: null,
            prices: {},
            coordinates: [],
            points: [],
        };
    },

    beforeDestroy() {
        this.$store.commit("setTollInfo", {});
        this.$store.commit("setTollCoordinates", []);
    },

    mounted() {
        let vm = this;
        $(".toll-calculation .select2").each(function () {
            let select = $(this);
            let { placeholder } = select.data();

            let id = select.attr("id");
            let data;

            if (id === "vehicle_category") {
                data = vm.vehicleCategory.map((vehicleCategory) => ({
                    id: vehicleCategory,
                    text: vm.trans.get(`map.${vehicleCategory}`),
                }));
            } else {
                data = vm.tollStations.map((station) => ({
                    id: station.id,
                    text: station.name,
                }));
                data.unshift({ id: "", text: vm.trans.get(`map.${id}`) });
            }

            select
                .select2({
                    dropdownParent: select.parent(".toll-container"),
                    placeholder: vm.trans.get(placeholder),
                    data: data,
                    templateResult: (state) => vm.templateResult(state, id),
                })
                .on("select2:select", function (e) {
                    vm[id] = e.target.value;
                    vm.checkForRequest();
                })
                .on("select2:open", function (e) {
                    const evt = "scroll.select2";
                    $(e.target).parents().off(evt);
                    $(window).off(evt);
                });

            if (id === "vehicle_category") {
                select.val("cat_I").trigger("change");
                vm[id] = "cat_I";
            }
        });
    },
    methods: {
        formatNumber(num) {
            return parseFloat(num).toFixed(2).replace(".", ",");
        },
        templateResult(state, id) {
            if (id === "exit_id" && state.id === this.start_id) {
                return null;
            }
            if (id === "start_id" && state.id === this.exit_id) {
                return null;
            }

            return state.text;
        },

        checkForRequest() {
            if (this.start_id && this.exit_id && this.vehicle_category) {
                this.$store.commit("setModal", null);

                let url = `${this.url}/${this.urlKey}`;
                let params = {
                    start_id: this.start_id,
                    exit_id: this.exit_id,
                };
                axios
                    .get(url, { params })
                    .then((res) => {
                        console.log(res);
                        Vue.set(this, "prices", res.data.prices);
                        Vue.set(this, "coordinates", res.data.coordinates);
                        Vue.set(
                            this,
                            "points",
                            res.data.points ? res.data.points : []
                        );
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            }
        },

        secondsToHms(d) {
            d = Number(d);
            var h = Math.floor(d / 3600);
            var m = Math.floor((d % 3600) / 60);
            var s = Math.floor((d % 3600) % 60);

            var hDisplay = h > 0 ? h : "0";
            var mDisplay = m > 0 ? m : "0";
            var sDisplay = s > 0 ? s : "0";
            return `${hDisplay}:${mDisplay < 10 ? "0" + mDisplay : mDisplay}`;
        },
    },

    computed: {
        ...mapGetters(["tollStations", "url", "vehicleCategory", "tollInfo"]),
        price() {
            if (Object.keys(this.prices).length) {
                return this.prices[this.vehicle_category]
                    ? this.prices[this.vehicle_category]
                    : null;
            }
            return null;
        },
    },

    watch: {
        coordinates(newValue) {
            let coords = newValue && newValue.length ? newValue : [];
            let payload = { category: "highways" };
            this.$store.commit("removeFilter", payload);
            this.$store.commit("setTollCoordinates", coords);
        },

        tollInfo(newValue) {
            if (Object.keys(newValue).length) {
                this.distance = newValue.distance
                    ? (newValue.distance / 1000).toFixed(1)
                    : "N/A";
                let secs = newValue.time ? newValue.time : 0;
                this.time = this.secondsToHms(secs);
            } else {
                this.distance = null;
                this.time = null;
                this.start_id = null;
                this.exit_id = null;
                this.vehicle_category = null;
                $(this.$refs.exit_id).val(null).trigger("change");
                $(this.$refs.start_id).val(null).trigger("change");
                $(this.$refs.vehicle_category).val(null).trigger("change");
            }
        },

        points(newValue) {
            if (newValue.length) {
                this.$store.commit("setTollPoints", newValue);
            } else {
                this.$store.commit("setTollPoints", []);
            }
        },
    },
};
</script>
